// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MarqueeText_wrap_2urIu","content":"MarqueeText_content_1yUP0","text":"MarqueeText_text_3doey","animation":"MarqueeText_animation_1mO9k","paused":"MarqueeText_paused_1RyIy"};